import React from 'react';
import './App.css';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Cards from './components/Cards/Cards';
import Social from './components/Socials/Social';
import './styles/style.scss';
import Faqs from './components/Faqs/Faqs';

function App() {
  return (
    <div className="App">
      <div className="wrapper">
        <Header />
        <Cards />
        <Social />
        <Faqs />
        <Footer />
      </div>
    </div>
  );
}

export default App;
